// Solid green "New" tag for recently shipped screens, so the team notices them.

export const NewBadge = ({ className = '' }: { className?: string }) => (
  <span
    data-testid="new-badge"
    className={`inline-flex items-center rounded bg-green-600 px-1.5 py-0.5 text-[10px] font-semibold uppercase leading-none tracking-wide text-white ${className}`}
  >
    New
  </span>
);
